import { InjectionToken } from '@angular/core';
import { AuthService } from './models/auth-service';

export let AUTH_SERVICE_TOKEN = new InjectionToken<AuthService>('authService');
